// Arrête la vidéo hero avant sa fin réelle (avant qu'un mouvement non désiré ne s'amorce), et la
// laisse figée sur cette dernière image — sans révéler l'image statique en dessous.
//
// Pourquoi pas de fondu vers l'image statique : l'image (hero-banniere-principale-01.png) et la
// vidéo ont été générées séparément par l'IA, la pose de la femme n'y est jamais identique.
// Peu importe où on coupe la vidéo, révéler l'image en dessous crée un saut visuel perceptible
// (constaté par l'utilisateur). En laissant la vidéo figée sur sa propre dernière image, aucun
// changement de pose ne peut apparaître.
//
// Pourquoi on fige aussi l'animation CSS (Ken Burns) à ce moment-là : certains navigateurs
// retracent/recalculent une vidéo à l'arrêt à chaque frame d'un `transform`/`scale` CSS animé,
// ce qui produisait un léger tremblement de l'image figée (constaté par l'utilisateur). On arrête
// donc le zoom en même temps que la vidéo — la scène devient totalement statique après la
// coupure plutôt que de continuer à zoomer sur une frame gelée.
//
// Ne se fie PAS à video.duration : les vidéos générées par IA ne sont souvent pas encodées en
// "faststart" (métadonnées de durée disponibles seulement en fin de fichier), donc
// video.duration peut rester Infinity/NaN jusqu'à la toute fin de la lecture. On utilise à la
// place la durée connue à la génération (attribut data-duration-seconds), fixe et fiable.
var HERO_VIDEO_FADE_MARGIN_SECONDS = 2;

document.querySelectorAll('.banner__video-bg').forEach(function (video) {
  var stopped = false;
  var knownDuration = parseFloat(video.dataset.durationSeconds);

  function stopVideo() {
    if (stopped) return;
    stopped = true;
    video.pause();
    video.classList.add('banner__video-bg--stopped');
  }

  function cutoffReached() {
    if (knownDuration) {
      return video.currentTime >= knownDuration - HERO_VIDEO_FADE_MARGIN_SECONDS;
    }
    return video.duration && video.currentTime >= video.duration - HERO_VIDEO_FADE_MARGIN_SECONDS;
  }

  video.addEventListener('timeupdate', function () {
    if (cutoffReached()) {
      stopVideo();
    }
  });

  video.addEventListener('ended', stopVideo);
});
